import React from 'react'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import Button from 'ui/buttons/Button'
import { Translation } from '@morningtrain/react-translations'
import * as Auth from '@morningtrain/react-auth'
import { ExecuteOperationForModelOnPipe } from '@morningtrain/react-resources'
import { AddRouteToPayloadOnPipe, NavigateOnPipe } from '@morningtrain/react-navigation'

export default function ReopenOrder (props) {
  return (
    <Auth.CanUseModel permission='api.inventory.order.reopen'>
      <Pipeline>
        <TriggerPipelineOnClick>
          <Button>
            <Translation name='actions.reset_order' />
          </Button>
        </TriggerPipelineOnClick>
        <ExecuteOperationForModelOnPipe operationName='reopen' />
        <AddRouteToPayloadOnPipe />
        <NavigateOnPipe
          route='app.inventory.order.edit'
          routeParameters={{
            inventory_supplier: 'payload:route.parameters.inventory_supplier',
            inventory_order: 'payload:route.parameters.inventory_order'
          }}
        />
      </Pipeline>
    </Auth.CanUseModel>
  )
}
